<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
        </div>
        <div class="modal-body">
          <div class="warning">
            <img width="48"
            :src="`${BaseUrl}assets/common/warning.png`"
            :srcset="`${BaseUrl}assets/common/warning@2x.png`">
            <span class="text" v-html="message"></span>
          </div>
          <div class="info-box">
            <h3 class="title">{{ mainTitle }}</h3>
            <div class="title-content">{{ titleContent }}</div>
            <div class="subtitle-group" v-for="(item, index) in infoContent" :key="index">
              <h4 class="subtitle" v-html="item.subtitle"></h4>
              <p class="content" v-html="item.content"></p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="checkbox checkbox-inline">
              <input type="checkbox" v-model="confirm_checkbox" id="edit_is_permit" />
              <label class="text-red" for="edit_is_permit">
                已確實取得客戶(準客戶)同意，進行資料編輯
              </label>
            </div>
          </div>
           <div class="action text-center">
            <a @click="doSubmit" class="btn btn-primary">{{ confirmText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WarningModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '確定'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      // 標題一
      mainTitle: "保單健檢服務同意條款",
      // 同意條款內文
      titleContent: `本人享有國泰世華商業銀行(以下稱「國泰世華銀行」)所提供之全方位保險規劃服務，茲同意國泰世華銀行經管理財專員於國泰人壽保險股份有限公司（以下簡稱「國泰人壽」）之保單健檢系統鍵入本人所提供之保單資訊（包含但不限於姓名、身分證字號、性別、年齡、保單明細資料），以供後續產出保單分析資料（包含但不限於保單明細、保障明細等相關資料），作為國泰世華銀行評估本人保障規劃及資產負債配置之用，以提供適當之理財服務。
      
      國泰世華銀行及國泰人壽應依「個人資料保護法」妥善運用及管理本人資料，本人亦有權隨時以書面通知國泰世華停止前述本人個人資料蒐集、處理、利用之行為，特此聲明。`,
      
      // 個資告知事項
      infoContent: [
        {
          // 這裡作為第二部分的標題使用
          subtitle: "個人資料蒐集、處理及利用告知事項",
          content: `由於台端為透過國泰世華商業銀行(以下稱 「國泰世華銀行」)與國泰人壽保險股份有限公司（以下簡稱「國泰人壽」）承保之保戶、準保戶、國泰世華銀行活動參加者或其他與國泰世華銀行進行服務聯繫(含申訴)相關業務往來關係之人，國泰世華銀行現在或將來可能因此取得台端的個人資料，於國泰世華銀行所設特定業務目的範圍內，直接或間接蒐集、處理、利用及國內外傳輸台端的個人資料，並存於國泰人壽保單健檢系統中。準此，謹請台端瞭解國泰世華銀行依據個人資料保護法(以下稱「個資法」)第八條，向台端告知下列事項，請台端詳閱：`
        },
        {
          subtitle: "一、 蒐集之目的：",
          content:
            `（一）人身保險（○○一）。<br>
             （二）其他經營合於營業登記項目或組織章程所定之業務（一八一）。<br>
             （三）消費者、客戶管理及服務（○九○）。<br>
             （四）調查、統計與研究分析（一五七）。<br>
             （五）行銷商品(○四○)與服務。<br>
             （六）消費者保護（九一）。<br>
             （七）民意調查（○二四）。<br>
             （八）契約、類似契約或其他法律關係事務（○六九）。<br>
             （九）金融服務業依法令規定及金融監理需要，所為之蒐集處理及利用<br>
                  <span class="ml-23">（○五九）。</span><br>
             （十）金融爭議處理（○六○）。<br>
             （十一）因活動需要或為提供保險相關服務及資訊而寄送簡訊、推播、傳真、電子<br>
                  <span class="ml-35">郵件給台端或致電與台端聯繫。</span>`
        },
        {
          subtitle: "二、蒐集之個人資料類別：",
          content:
            `蒐集台端或台端所提供之家人資訊，包括但不限於保單號碼、姓名、性別、年齡、職業、身分證統一編號、生日、聯絡方式(如：通訊地址、電話號碼、電子郵件信箱、偏好聯絡方式)、財務情況(如：信用卡資訊)、及其他得以直接或間接方式識別該個人之資料。`
        },
        {
          subtitle: "三、個人資料利用之期間、對象、地區、方式：",
          content:
            `（一）期間：個人資料蒐集之特定目的存續期間、執行職務或業務所必須及依法令<br>
                  <span class="ml-52">規定應為保存之期間。</span><br>
             （二）對象：國泰世華銀行、國泰人壽、合作廠商(如：服務、行銷供應商)、中華<br>
                  <span class="ml-52">民國人壽保險商業同業公會、業務委外機構、客戶資訊相關作業之</span><br>
                  <span class="ml-52">委外機構、未受中央目的事業主管機關限制之國際傳輸個人資料之</span><br>
                  <span class="ml-52">接收者及依法有調查權機關或金融監理機關。</span><br>
             （三）地區：上述對象所在之地區(含國內及國外)。<br>
             （四）方式：合於法令規定之利用方式。`
        },
        {
          subtitle: "四、依據個資法第三條規定，台端就國泰世華銀行保有台端的個人資料得行使之權利及方式：",
          content:
            `（一）得向國泰世華銀行行使之權利：<br>
                  <span class="ml-26">1.向國泰世華銀行查詢、請求閱覽或請求製給複製本。</span><br>
                  <span class="ml-26">2.向國泰世華銀行請求補充或更正。</span><br>
                  <span class="ml-26">3.向國泰世華銀行請求停止蒐集、處理或利用及請求刪除。惟因執行職務</span><br>
                  <span class="ml-35">或業務所必須之個人資料，國泰世華銀行依個資法第十一條規定，得</span><br>
                  <span class="ml-35">不同意台端的請求。</span><br>
             （二）行使權利之方式：台端得向本行客服(0800-818-001或(02)2383-1000）詢<br>
                  <span class="ml-26">問或於本行網站（網址：www.cathaybk.com.tw/cathaybk/）查詢 。</span>`
        },
        {
          subtitle: "五、台端不提供個人資料所致權益之影響：",
          content:
            `台端若未能提供相關個人資料時，國泰世華銀行將可能延後或無法進行保單規劃及處理作業，或無法獲得國泰世華銀行提供之相關服務及資訊或國泰世華銀行可能遲延提供台端相關服務，敬請諒察。`
        },
      ],
      confirm_checkbox: false,
    }
  },
  watch: {
    open(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden"; // 禁用滾動
      } else {
        document.body.style.overflow = ""; // 恢復滾動
      }
    },
    message() {
      this.registerHanlink()
    },
  },
  computed: {
    ...mapGetters(["UserInfo", "BaseUrl"]),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === "box";
    }
  },
  methods: {
    doSubmit() {
      if (!this.confirm_checkbox) {
        this.$toast.info({ title: '未經客戶同意編輯資料' })
        return
      }
      this.$emit('submit')
    }
  }
}
</script>

<style scoped>
.info-box {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  max-height: 350px;
  overflow-y: auto;
  margin: 16px 0;
  scrollbar-color: #bdbebd transparent;
}
.info-box .title {
  text-align: center;
  color: #396337;
  font-size: 26px;
  font-weight: bold;
  margin-top: 15px;
}
.info-box .subtitle-group {
  margin-bottom: 16px;
}
.info-box .subtitle {
  color: #85b168;
  font-weight: bold;
  margin-bottom: 8px;
}
.info-box .title-content, .info-box .content {
  color: #000;
  font-size: 14px;
  line-height: 1.6;
}
.checkbox .text-red {
  color: red;
}
.action {
  margin-top: 16px;
}
.action a {
  margin: 0 8px;
  padding: 8px 16px;
}
.btn-secondary {
  background-color: #548235;
  color: white;
  border: 1px solid#476b2d; 
  border-radius: 4px;
}
.btn-secondary:hover {
  background-color: #679f41;
}
.modal.is-open {
  display: block;
}
.modal.fade .modal-dialog.modal-sm {
  margin: 8% auto !important;
}
/deep/ .ml-23 {
  margin-left: 2.3rem !important;
}
/deep/ .ml-25 {
  margin-left: 2.5rem !important;
}
/deep/ .ml-26 {
  margin-left: 2.6rem !important;
}
/deep/ .ml-35 {
  margin-left: 3.5rem !important;
}
/deep/ .ml-52 {
  margin-left: 5.2rem !important;
}
.modal.fade .modal-header {
  padding: 5px !important;
}
</style>
